import CargoCompanyAddressFetchInitData from "../../../../../common/services/cargo-company/address/fetch-init-data/cargo-company-address-fetch-init-data";
import CargoCompanyAddressUpdateParams from "../../../../../common/services/cargo-company/address/update/cargo-company-address-update-params";
import { SearchAddressResponseItem } from "../../../../../common/utils/search-address/search-address.response";
import cargoTranslationsHelper from "../../../../../languages/cargo-translations.helper";
import CargoAddressFormData from "../../common/types/cargo-address-form-data";
import CargoAddressType from "../../../../../common/types/cargo-address-type";
import CargoAddressTypeSelectOption from "../../common/types/cargo-address-type-select-option";
import CargoAddressEditAddress from "./types/cargo-address-edit-address";
import CargoAddressEditAddressFormData from "./types/cargo-address-edit-address-form-data";
import CargoAddressEditAddressSelectOption from "./types/cargo-address-edit-address-select-option";
import CargoAddressEditFormCoordinates from "./types/cargo-address-edit-form-coordinates";

const createAddress = (
  searchAddressResponseItem: SearchAddressResponseItem,
): CargoAddressEditAddress => {
  const address: CargoAddressEditAddress = {
    displayName: searchAddressResponseItem.display_name,
    apartmentNumber: "",
    country: searchAddressResponseItem.address.country,
    houseNumber: searchAddressResponseItem.address.house_number ?? "",
    latitude: Number(searchAddressResponseItem.lat),
    longitude: Number(searchAddressResponseItem.lon),
    street: searchAddressResponseItem.address.road ?? "",
    town:
      searchAddressResponseItem.address.city ??
      searchAddressResponseItem.address.town ??
      searchAddressResponseItem.address.village ??
      "",
    zipCode: searchAddressResponseItem.address.postcode ?? "",
  };

  return address;
};

const createAddressSelectOption = (
  searchAddressResponseItem: SearchAddressResponseItem,
): CargoAddressEditAddressSelectOption => {
  const address = createAddress(searchAddressResponseItem);

  return {
    label: searchAddressResponseItem.display_name,
    value: address,
  };
};

const createAddressSelectOptions = (
  searchAddressResponseItems: SearchAddressResponseItem[],
): CargoAddressEditAddressSelectOption[] => {
  return searchAddressResponseItems.map(createAddressSelectOption);
};

const createEditCargoAddressUpdateRequest = (
  cargoCompanyUuid: string,
  addressUuid: string,
  formData: CargoAddressFormData,
  addressCoordinates: CargoAddressEditFormCoordinates,
): CargoCompanyAddressUpdateParams => {
  return {
    lat: addressCoordinates.latitude,
    lon: addressCoordinates.longitude,
    country: formData.country.trim(),
    town: formData.town.trim(),
    zipCode: formData.zipCode.trim(),
    street: formData.street.trim(),
    houseNo: formData.houseNumber.trim(),
    apartment: formData.apartmentNumber.trim(),
    description: formData.description.trim(),
    type: formData.addressType?.value!,
    addressUuid: addressUuid,
    cargoCompanyUuid: cargoCompanyUuid,
  };
};

const createAddressTypeSelectOption = (
  responseAddressType: CargoAddressType,
): CargoAddressTypeSelectOption => {
  const translations =
    cargoTranslationsHelper.getAddressEditTranslations().address.addressType;

  return {
    label: translations[responseAddressType],
    value: responseAddressType,
  };
};

const recreateAddressTypeSelectOption = (
  item: CargoAddressType,
): CargoAddressTypeSelectOption => {
  const translations =
    cargoTranslationsHelper.getAddressEditTranslations().address.addressType;

  return {
    label: translations[item],
    value: item,
  };
};

const createFormData = (
  responseItem: CargoCompanyAddressFetchInitData,
): CargoAddressEditAddressFormData => {
  return {
    latitude: responseItem.lat,
    longitude: responseItem.lon,
    country: responseItem.country ?? "",
    town: responseItem.town ?? "",
    zipCode: responseItem.zipCode ?? "",
    street: responseItem.street ?? "",
    houseNumber: responseItem.houseNo ?? "",
    apartmentNumber: responseItem.apartment ?? "",
    description: responseItem.description ?? "",
    addressType: createAddressTypeSelectOption(responseItem.type),
  };
};

const cargoAddressEditFactory = {
  createAddress,
  createAddressSelectOptions,
  createEditCargoAddressUpdateRequest,
  createFormData,
  createAddressTypeSelectOption,
  recreateAddressTypeSelectOption,
};

export default cargoAddressEditFactory;
